import { CheckCircleFilled, ClockCircleOutlined, MinusCircleOutlined } from '@ant-design/icons';
import { memo } from 'react';

interface StatusIconProps {
  status: Conversation.Status;
}

export const StatusIcon = memo((props: StatusIconProps) => {
  const { status } = props;

  if (status === 'ONLINE') {
    return <CheckCircleFilled className="!text-success" />;
  }

  if (status === 'HANGUP') {
    return <ClockCircleOutlined className="!text-warning" />;
  }

  if (status === 'OFFLINE') {
    return <MinusCircleOutlined className="!text-error" />;
  }

  return null;
});
